import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'

// We can inject some CSS into the DOM.

const styles = () => ({
  root: {
    height: '36px',
    padding: '0 16px',
  },
})

function ClassNames(props) {
  const { onClick, variant, ...rest } = props
  return (
    <ThemeProvider theme={theme}>
      <LightButton
        variant={variant}
        color="secondary"
        className={props.classes.root}
        style={{ ...props.style }}
        onClick={onClick}
        {...rest}
      >
        {props.children ? props.children : 'class names'}
      </LightButton>
    </ThemeProvider>
  )
}

ClassNames.defaultProps = {
  variant: 'outlined',
}

const LightButton = styled(Button)`
  && {
    color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.white};
    &:hover {
      border-color: ${props => props.theme.colors.white};
      background-color: ${props => props.theme.buttons.lightButtonBgHover};
    }
    &:disabled {
      color: ${props => props.theme.colors.white};
      opacity: 0.3;
    }
  }
`

const SecondaryButtonLight = withStyles(styles)(ClassNames)
SecondaryButtonLight.displayName = 'SecondaryButtonLight'
export default SecondaryButtonLight
